export const SERVER_URL = process.env.REACT_APP_SERVER_URL ||  "https://api.kozoom.com";
// export const SERVER_URL = "https://localhost:8000";
export const UPLOADED_MEDIA_URL = `https://b-cdn.kozoom.com/`;
export const FEDERATION_IMAGE_URL = `https://kozoom.b-cdn.net/federations/`;
export const CHAT_SOCKET_SERVER_URL = process.env.REACT_APP_CHAT_SOCKET_SERVER_UR || "https://live-server.kozoom.com";
